import { render, staticRenderFns } from "./Curators.vue?vue&type=template&id=13ebbd80&scoped=true&"
import script from "./Curators.vue?vue&type=script&lang=js&"
export * from "./Curators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebbd80",
  null
  
)

export default component.exports